import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { NumberView } from "@/components/NumberView";

// Unified number/contact page: same view whether opened from Contacts or from
// the calls list (mobile). One component, one source of truth.
const ContactDetail = () => {
  const { key } = useParams();
  const navigate = useNavigate();

  return (
    <div data-testid="contact-detail-page" className="space-y-6 max-w-3xl">
      <button
        type="button"
        data-testid="back-button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-emerald-700 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" /> Retour
      </button>
      <NumberView numberKey={key} onDeleted={() => navigate("/contacts")} />
    </div>
  );
};

export default ContactDetail;
